import TopHeader from './headers/top'
import BottomHeader from './headers/bottom';
import Style from './style.module.css'

const Header = ({topTabs, bottomTabs, isBottom = true, className, CustomBottom}) => {
  return (
    <header className={`${Style.siteHeader} ${className?.siteHeader}`}>
      <TopHeader topTabs={topTabs} style={Style} className={className} />

      {isBottom &&
        <BottomHeader bottomTabs={bottomTabs} style={Style} className={className} />
      }
      {CustomBottom &&
        <CustomBottom />
      }
    </header>
  )
}

export default Header
